/*
feedToggle.js
This module handles the feed toggle buttons (e.g. Discover/Follow) and the sort dropdown functionality.
*/

export function initFeedToggle(config) {
    const { currentSortMode, currentFeedType } = config;
  
    // -------------------------------------
    // FEED TOGGLE LOGIC (DISCOVER/FOLLOW)
    // -------------------------------------
    const toggleButtons = document.querySelectorAll('.feed-toggle button:not(#openUserSearch)');
    toggleButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const feedType = btn.getAttribute('data-feed-type');
        // Navigate while preserving the current sort mode
        window.location.href = `/feed?feed_type=${feedType}&sort=${currentSortMode}`;
      });
    });
  
    // -------------------------------------
    // SORT DROPDOWN LOGIC
    // -------------------------------------
    const sortOptions = document.querySelectorAll('.sort-option');
    sortOptions.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        const selectedSort = option.getAttribute('data-sort');
        // Navigate using the current feed type and the selected sort option
        window.location.href = `/feed?feed_type=${currentFeedType}&sort=${selectedSort}`;
      });
    });
  }
  